import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { copy } from "@/utils/clipboard";
import localize from "@/utils/localization";
import DatasetSourceTransform from "@/components/DatasetInformation/DatasetSourceTransform.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetSource',
    props: {
        source: null
    },
    setup(__props) {
        const props = __props;
        library.add(faCopy, faExternalLinkAlt);
        const sourceUri = computed(() => {
            return props.source.source_uri;
        });
        const browserCompatUri = computed(() => {
            return sourceUri.value && (sourceUri.value.indexOf("http") == 0 || sourceUri.value.indexOf("ftp") == 0);
        });
        function copyLink() {
            copy(sourceUri.value, localize("Link copied to your clipboard"));
        }
        return { __sfc: true, props, sourceUri, browserCompatUri, copyLink, faCopy, faExternalLinkAlt, FontAwesomeIcon, DatasetSourceTransform };
    }
});
